import React, { FC } from 'react';

const InfoWindow: FC<{ show: boolean }> = ({ show, children }) =>
  show ? (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div className="dvinci-widget-maps-info-window card shadow" onClick={(event) => event.stopPropagation()}>
      {children}
    </div>
  ) : (
    <></>
  );

export default InfoWindow;
